import { between, down, up } from "styled-breakpoints";
import styled from "styled-components";

export const Wrapper = styled.footer`
    margin-top: 0.748rem;
    background: #f3faf2;
    width: 100%;
    overflow: hidden;

    .privacy_and_conditions {
        background-color: #262626;
        padding: 24px 0;

        .d-flex.container {
            column-gap: 1rem;
            ${down("sm")} {
                flex-wrap: wrap;
                row-gap: 14px;
                column-gap: 0;
            }

            a:nth-child(2),
            a:nth-child(3) {
                //border-left: 1px solid white;
                //padding-left: 20px;
                ${down("sm")} {
                    border-left: none;
                    padding-left: 0;
                }
            }

            a {
                flex-grow: 0;
                flex: none;
                ${down("sm")} {
                    flex: 1 1 0%;
                }
            }

            p.copyright-text {
                flex: 1 1 0%;
                text-align: end;
                ${down("sm")} {
                    flex: none;
                    flex-basis: 100%;
                    text-align: center;
                }
            }

            & > * {
                color: rgb(255 255 255);
            }

            a,
            p {
                font-size: 14px;
                font-weight: 400;
                line-height: 16.8px;
                text-align: center;
            }
        }
    }

    .first_section {
        .container {
            margin: auto;
            display: grid;
            align-items: center;
            padding: 40px 0;
            grid-template-columns: repeat(3, minmax(0, 1fr));

            ${down("md")} {
                display: flex;
                flex-direction: column-reverse;
                row-gap: 3rem;
                text-align: center;
            }

            .navigations_and_contact {
                grid-column: span 2 / span 2;

                ${down("md")} {
                    width: 100%;
                    padding: 0 4rem;
                }

                ${between("xs", "sm")} {
                    width: 100%;
                    padding: 0 3rem;
                }

                .context {
                    display: flex;
                    align-items: baseline;
                    justify-content: space-between;

                    & > * {
                        flex-basis: 33.333333%;
                    }

                    ${down("md")} {
                        flex-direction: column-reverse;
                        & > * {
                            flex-basis: 100%;
                        }
                    }

                    div {
                        h5.title {
                            font-size: 16px;
                            color: rgb(9 152 25);
                            font-weight: 500;
                        }

                        h6.subtitle {
                            font-size: 14px;
                        }

                        .google-store-link, .apple-store-link {
                            display: contents;
                        }
                    }

                    .download {
                        display: flex;
                        flex-direction: column;
                        row-gap: 0.5rem;

                        .apple-store-link svg {
                            ${down("md")} {
                                height: 100% !important;
                                width: 101px !important;
                            }
                            ${up("md")} {
                                height: 100% !important;
                            }
                        }
                    }

                    .navigation {
                        ul li {
                            line-height: 30px;
                        }
                    }

                    .newsletter {
                        display: flex;
                        flex-direction: column;
                        row-gap: 0.5rem;

                        ${down("md")} {
                            width: 100%;
                        }

                        form {
                            .form_group {
                                max-width: 100%;
                                position: relative;
                                border-radius: 900px;
                                overflow: hidden;
                                outline: 1px solid green;

                                ${up("md")} {
                                    max-width: 90%;
                                }

                                input[type="email"] {
                                    width: 100%;
                                    background: transparent;
                                    padding: 10px;
                                    padding-inline-start: 2.2rem;
                                    border: none;
                                    font-size: 12px;
                                }

                                span.form_icon {
                                    position: absolute;
                                    font-size: 14px;
                                    right: 100%;
                                    transform: translate(0px, -50%);
                                    left: 10px;
                                    top: 50%;
                                }
                            }

                            button {
                                font-size: 14px;
                                font-weight: 600;
                                line-height: 16.8px;
                                text-align: center;
                                color: #fafafa;
                                padding: 0.6rem 1.2rem;

                                ${down("md")} {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    ${down("md")} {
                        .download,
                        .navigation {
                            display: none;
                        }
                    }
                }
            }

            .social_links {
                display: flex;
                flex-direction: column;
                column-gap: 10px;

                ${down("md")} {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    padding: 0 4rem;
                }

                ${between("xs", "sm")} {
                    width: 100%;
                    padding: 0 3rem;
                }

                .agrogrid_brand {
                    width: 143.64px;

                    ${down("md")} {
                        max-width: 107.73px;
                    }
                }

                .social_btns {
                    margin-top: 40px;

                    ${down("md")} {
                        margin-top: 20px;
                    }

                    p {
                        margin: 1rem 0;
                        font-weight: 500;
                        color: #099819;
                    }

                    div {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                }
            }
        }
    }

    hr {
        margin: 0;
    }

    .contact_us {
        ${down("sm")} {
            display: none;
        }

        .container {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            padding: 24px 0;

            div {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                column-gap: 5px;

                a {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16.8px;
                    text-align: center;
                }
            }
        }
    }
`;